<template>
  <footer>
    <p><small>{{$t('fotter.copyright')}}</small></p>
  </footer>
</template>

<script>
export default {};
</script>

<style scoped>
footer p {
  color: gray;
  text-align: right;
  margin-right: 1rem;
  pointer-events: none;
}
</style>
